import moment from 'moment'
import validationMixin from '../utils/validationMixin'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

export default {
  name: 'FormDatetime',
  mixins: [validationMixin, textFieldMixin],

  props: {
    required: Boolean,
    value: String
  },

  data: () => ({
    datetime: null,
    menu: false
  }),

  created () {
    // expect value in UTC format with timezone (from java Instant, e.g. 2013-05-30T23:38:23.085Z)
    const momentValue = this.value ? moment(this.value) : moment().startOf('day')

    // align date with string value expected by v-date-picker
    // TODO use i18n locale to configure v-date-picker format and headers
    this.datetime = momentValue.format('YYYY-MM-DD')

    // update parent with current value in UTC format
    this.$emit('input', momentValue.toISOString())
  },

  methods: {
    handleDatePickerInput (item, event) {
      // update parent with current value in UTC format
      this.$emit('input', moment(item).toISOString())
      this.menu = false
    },

    trigMenu () {
      if (!this.menu) this.menu = true
    },

    clearValue () {
      this.datetime = null
      this.$emit('input', this.datetime)
    }
  }
}
